$(document).ready(function () {

    function sliceOffHashtagIfExists(queryString) {
        var indexOfHash = queryString.indexOf('#');
        if (indexOfHash !== -1) {
            queryString = queryString.substring(0, indexOfHash);
        }
        return queryString;
    }

    function getParameterByName(name, url) {
        var indexOfQueryString = url.indexOf('?');
        if (indexOfQueryString === -1) {
            return "";
        }

        var queryString = url.substring(indexOfQueryString + 1);
        queryString = sliceOffHashtagIfExists(queryString);

        var vars = queryString.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] === name) {
                var value = pair[1];
                return decodeURIComponent(value);
            }
        }

        return "";
    }

    function getReturnUrlFromCurrentQueryString() {
        var url = window.location.href;
        var returnUrlParam = getParameterByName('returnUrl', url);
        var hash = window.location.hash;

        return returnUrlParam + hash;
    }
    
    function setReturnUrlInLogonForm(returnUrl) {
        $('input[name=ReturnUrl]').val(returnUrl);
    }

    //'performance.navigation.redirectCount' 1 means the login page was reached via redirect. 'redirectCount' is used instead of 'type' because type still
    //showed 0 when the URL was entered (or pasted) directly in the browser. In any case this means that the user navigated to a restricted page while not
    //logged in and hence was redirected. If the URL of the page, from which he was redirected, contained an anchor (#...), the server, that made the redirect,
    //was not aware of this, because anchors are not submitted to the server. Therefore the server had no way to include this anchor in the returnUrl
    //(see CultureAuthorizeAttribute.HandleUnauthorizedRequest) and later the viewModel (see AccountController.LogOn(string)). The browser on the other hand
    //keeps the anchor on redirects (see https://tools.ietf.org/html/rfc7231#section-7.1.2). We take advantage of this and store the complete returnUrl and the
    //anchor in the form field 'ReturnUrl'. If the login fails and the user stays on the login page we have the same problem as before, that the anchor is not
    //submitted to the server. As we are not redirected this time, the browser also does not preserve the anchor. Luckily we stored the complete returnUrl as
    //form field during the initial page load, which was then submitted to the server. The server, now being aware of the anchor (because it was a normal value
    //in a (hidden) form field), returned this exact value in the form of the login page. So we have the opposite situation than on the first login page load.
    //The returnUrl in the form is the complete URL (including the anchor) but the URL in the browser window lacks this anchor because the browser did not
    //preserve it this time. That is why we only want to set the returnUrl in the form when we are redirected to the login page and not when the login page was
    //loaded a second or third time (most likely because of invalid credentials).
    if (window.performance.navigation.redirectCount === 1) {
        var returnUrl = getReturnUrlFromCurrentQueryString();
        setReturnUrlInLogonForm(returnUrl);
    }
});
